module.exports = __webpack_public_path__ + "img/risk-calculate.45fc9568.png";